import { Modal, ModalId } from "../../../ui"
import { DataType, TableName } from "../../../../tables"
import { useActions } from "./actions"
import { useDescribeHooks } from "../../hooks/describeHooks"

type Props = {
    tableName: TableName
    dataType?: DataType
}

export const RemoveModal = (props: Props) => {
    const { tableName, dataType } = props

    const { describe } = useDescribeHooks()

    const { removeDataType } = useActions()

    const renderBody = () => dataType ? <>
        Está por eliminar: <b>{describe(tableName, dataType)}</b>. <br />
        Esta acción es irreversible.
    </> : <></>

    const onSubmit = () => removeDataType(tableName, dataType!.id)
    
    return (
        <Modal
            modalId={ModalId.REMOVE}
            title="Eliminar Registro?"
            submitLabel="Eliminar"
            submitKind="secondary"
            onSubmit={onSubmit}
        >
            {renderBody()}
        </Modal>
    )
}
